interface IStringIndex {
  [key: string]: any;
}

const EnvVars: IStringIndex = {
  dev: {
    REACT_APP_USERPROFILE_SERVICE_APIGEEX: 'https://developer-dev.api.autodesk.com/unifieduserprofile',
    ADSK_LOG_SERVICE_INFO_URL: 'https://uilogs.profile-dev.autodesk.com/log/info',
    ADSK_LOG_SERVICE_ERROR_URL: 'https://uilogs.profile-dev.autodesk.com/log/error',
    ADSK_PROFILE_URL: 'https://profile-dev.autodesk.com/personalinfo',
    ADSK_AEM_URL: 'https://www-pt.autodesk.com/api/assets/cfp/',
    ADSK_PRIVACY_URL: 'https://www.autodesk.com/company/legal-notices-trademarks/privacy-statement',
    CONTENTFUL_SPACE_ID: 'v7wr16nrr0mz',
    CONTENTFUL_ENVIRONMENT: 'staging',
    CONTENTFUL_ENTRY_ID: '7hlQK2NGxnuFJySX5FuFVh',
    CONTENTFUL_DELIVERY_TOKEN: 'DjiuTd5OG4fUjdA7S41aIclLak87LprA0yAERahn9Ws',
  },
  stg: {
    REACT_APP_USERPROFILE_SERVICE_APIGEEX: 'https://developer-stg.api.autodesk.com/unifieduserprofile',
    ADSK_LOG_SERVICE_INFO_URL: 'https://uilogs.profile-stg.autodesk.com/log/info',
    ADSK_LOG_SERVICE_ERROR_URL: 'https://uilogs.profile-stg.autodesk.com/log/error',
    ADSK_PROFILE_URL: 'https://profile-stg.autodesk.com/personalinfo',
    ADSK_AEM_URL: 'https://www-pt.autodesk.com/api/assets/cfp/',
    ADSK_PRIVACY_URL: 'https://www.autodesk.com/company/legal-notices-trademarks/privacy-statement',
    CONTENTFUL_SPACE_ID: 'v7wr16nrr0mz',
    CONTENTFUL_ENVIRONMENT: 'staging',
    CONTENTFUL_ENTRY_ID: '7hlQK2NGxnuFJySX5FuFVh',
    CONTENTFUL_DELIVERY_TOKEN: 'DjiuTd5OG4fUjdA7S41aIclLak87LprA0yAERahn9Ws',
  },
  prd: {
    REACT_APP_USERPROFILE_SERVICE_APIGEEX: 'https://developer.api.autodesk.com/unifieduserprofile',
    ADSK_LOG_SERVICE_INFO_URL: 'https://uilogs.profile.autodesk.com/log/info',
    ADSK_LOG_SERVICE_ERROR_URL: 'https://uilogs.profile.autodesk.com/log/error',
    ADSK_PROFILE_URL: 'https://profile.autodesk.com/personalinfo',
    ADSK_AEM_URL: 'https://www.autodesk.com/api/assets/cfp/',
    ADSK_PRIVACY_URL: 'https://www.autodesk.com/company/legal-notices-trademarks/privacy-statement',
    CONTENTFUL_SPACE_ID: 'v7wr16nrr0mz',
    CONTENTFUL_ENVIRONMENT: 'master',
    CONTENTFUL_ENTRY_ID: '7hlQK2NGxnuFJySX5FuFVh',
    CONTENTFUL_DELIVERY_TOKEN: 'DjiuTd5OG4fUjdA7S41aIclLak87LprA0yAERahn9Ws',
  },
};

export default EnvVars;
